// Tokenized public links (invitation accept, password reset, email-change
// confirm) carry their token in the URL *fragment* (#token=...): browsers
// never send fragments to any server, so the token can't reach access logs
// nor page-view analytics (Umami auto-track). Older emails still carry the
// legacy path-param form (/invitations/:token), so callers pass the React
// Router path param as a fallback.
export function tokenFromLocation(location, pathToken) {
  const hash = (location && location.hash) || "";
  const match = hash.match(/[#&]token=([^&]+)/);
  if (match) return decodeURIComponent(match[1]);
  return pathToken || null;
}
